import React, { useState } from 'react';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../config/firebase';
import { logAuthEvent } from '../utils/logging';

interface ResetPasswordProps {
  onBack: () => void;
}

const ResetPassword: React.FC<ResetPasswordProps> = ({ onBack }) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const normalizedEmail = email.trim().toLowerCase();

    try {
      setError('');
      setMessage('');
      setLoading(true);

      logAuthEvent({
        event: 'password_reset_requested',
        email: normalizedEmail
      }).catch((logErr) => console.error('Auth log failed:', logErr));

      await sendPasswordResetEmail(auth, normalizedEmail);

      logAuthEvent({
        event: 'password_reset_email_dispatched',
        email: normalizedEmail
      }).catch((logErr) => console.error('Auth log failed:', logErr));

      setMessage(
        'If this email is on file, we will send a password reset link. If it does not arrive within a few minutes, check your spam or junk folder.'
      );
      setEmail('');
    } catch (err: any) {
      console.error('Reset password error:', err);

      logAuthEvent({
        event: 'password_reset_email_dispatch_failed',
        email: normalizedEmail,
        error: err?.message || 'Unknown reset password error',
        details: {
          errorCode: err?.code || 'unknown',
          errorName: err?.name || 'unknown'
        }
      }).catch((logErr) => console.error('Auth log failed:', logErr));

      setError('We could not process your request right now. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <h2>Reset Password</h2>
      {error && <div className="error">{error}</div>}
      {message && <div className="success">{message}</div>}
      <form onSubmit={handleSubmit}>
        <div>
          <label>Email:</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={loading}
            placeholder="Enter your email"
          />
        </div>
        <button type="submit" disabled={loading}>
          {loading ? 'Sending...' : 'Send Reset Link'}
        </button>
      </form>
      <div className="auth-links">
        <button 
          className="link-button"
          onClick={onBack}
          disabled={loading}
        >
          Back to Login
        </button>
      </div>
    </div>
  );
};

export default ResetPassword; 